Bingo.FavouriteOffersGrid = {};

Bingo.FavouriteOffersGrid.init = function () {
    $('.js-favouriteOffersGrid').masonry({
        columnWidth: 280,
        horizontalOrder: true,
        itemSelector: '.js-favouriteOffersGrid__item',
        gutter: 30,
        isFitWidth: true,
    });

    $(window).resize(() => this.reload());
};

Bingo.FavouriteOffersGrid.destroy = function () {
    $(window).off('resize', this.reload());
    $('.js-favouriteOffersGrid').masonry('destroy');
};

Bingo.FavouriteOffersGrid.reload = function () {
    $('.js-favouriteOffersGrid').masonry('reloadItems').masonry('layout');
};
